const ACTIONS = { SHOW: 'ADD_ERROR', HIDE: 'REMOVE_ERROR' };

const reducer = (state, action) => {
  switch (action.type) {
    case 'showError':
      return { ...state, showError: true };
    case 'removeError':
      return { ...state, showError: false };
    default:
      return;
  }
};

export { reducer, ACTIONS };
